import { sendNotifyMessage } from '@/api/orders';
import {
  SNACKBAR_TYPES,
} from '@/utils/constants';

export default {
  name: 'ReceiveNotificationModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      title: '發送領取通知',
      notifyList: [{
        text: 'Email 通知',
        icon: 'icon-mail',
        enabled: true,
        key: 2,
      }],
    };
  },
  computed: {
    selectedPlatform() {
      return this.notifyList.filter((ele) => ele.enabled).map((ele) => ele.key);
    },
    isNotSend() {
      return !this.selectedPlatform?.length;
    },
  },
  methods: {
    async sendNotifyImmediately() {
      if (this.isNotSend) {
        return;
      }
      try {
        await sendNotifyMessage(this.order.id, {
          types: this.selectedPlatform,
        });
        this.closeModal();
        this.$snackbar({
          title: '領取通知發送成功',
          type: SNACKBAR_TYPES.SUCCESS,
        });
      } catch (error) {
        this.$snackbar({
          msg: '發送失敗，請稍後再試一次',
          type: SNACKBAR_TYPES.ERROR,
        });
      }
    },
    closeModal() {
      this.$emit('input', false);
      this.$emit('close');
    },
  },
};
